import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Main from "./Components/Main";
import Footer from "./Components/footer";
import About from "./Components/About";
function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Main />
      <About />
      <Footer />
    </>
  );
}

export default App;
